/** localStorage, not sessionStorage: a magic link can open in a new tab. */
const RETURN_KEY = 'reportpad.returnTo';

/** Remembers where to come back to after sign-in; defaults to the current page. */
export function rememberReturnPath(path?: string): void {
  try {
    localStorage.setItem(RETURN_KEY, path ?? window.location.pathname + window.location.search);
  } catch {
    // Storage blocked: the person just lands on the home page after signing in.
  }
}

/** The stored return path, removed on read; only same-app, non-auth paths. */
export function takeReturnPath(): string {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(RETURN_KEY);
    localStorage.removeItem(RETURN_KEY);
  } catch {
    raw = null;
  }
  if (
    raw !== null &&
    raw.startsWith('/') &&
    !raw.startsWith('//') &&
    !raw.startsWith('/\\') &&
    !raw.startsWith('/login') &&
    !raw.startsWith('/auth/')
  ) {
    return raw;
  }
  return '/';
}
